
export default [{
	path: '/brands',
	component: () => import('@/components/brands/List')
}]
